// Kakao Maps SDK initializer
// https://apis.map.kakao.com/web/documentation/
import Script from "next/script";

declare global {
  interface Window {
    kakao: {
      maps: {
        LatLng: new (lat: number, lng: number) => any;
        Map: new (container: HTMLElement, options: any) => any;
        Marker: new (options: any) => any;
        MarkerImage: new (src: string, size: any, options?: any) => any;
        MarkerClusterer: new (options: any) => any;
        Size: new (width: number, height: number) => any;
        Point: new (x: number, y: number) => any;
        event: {
          addListener: (target: any, type: string, callback: () => void) => void;
        };
      };
    };
    kakaoMapsReady?: boolean;
  }
}

export function KakaoMapsInitializer() {
  return (
    <Script
      src={`//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.NEXT_PUBLIC_KAKAO_MAP_KEY}&libraries=services,clusterer`}
      strategy="afterInteractive"
      onReady={() => {
        // SDK가 완전히 로드됨
        window.kakaoMapsReady = true;
      }}
    />
  );
}
